import "./App.css";

import React from "react";
import { Route, Routes } from "react-router-dom";
import PatchPage from "./pages/patch-page";

const App: React.FC = () => (
  <Routes>
    <Route path="/" element={<PatchPage />} />
  </Routes>
);

export default App;
